import React from "react";
import { useTranslation } from "react-i18next";

const InfoWidget = ({ zone }) => {
  const { t } = useTranslation();
  return (
    <div className="text-right">
      <div>
        <i className="circleTop icon-plug text-center m-auto"></i>
        <div className="text-center mt-2">
          <p className="m-0">{t("اطلاعات ویجت")}</p>
        </div>
      </div>

      <div className="my-4">
        <div className="widgetInfo bg-white p-3">
          <div>
            <p className="fn12 text-muted">{t("نام دستگاه")}</p>
            <p className="fn12">{zone.genesis}</p>
          </div>
          <div>
            <p className="fn12 text-muted">{t("دسته بندی ویجت")}</p>
            <p className="fn12">{zone.property[1]}</p>
          </div>
          <div>
            <p className="fn12 text-muted">{t("سریال دستگاه ویجت")}</p>
            <p className="fn12">{zone.serial}</p>
          </div>
          <div>
            <p className="fn12 text-muted">{t("شماره ویجت")}</p>
            <p className="fn12">{zone.index + 1}</p>
          </div>
        </div>
      </div>

      <div>
        <div className="text-center mt-2">
          {/* <p className="fn12">مشاهده تاریخچه</p> */}
          {/* <button type="button" class="btn btn-primary">مشاهده تاریخچه</button> */}
          <button
            type="button"
            class="btn btn-outline-danger"
            style={{ fontSize: "12px" }}
          >
            {t("مشاهده تاریخچه")}
          </button>
        </div>
      </div>
    </div>
  );
};

export { InfoWidget };
